import { useState, useEffect } from 'react';
import Image from 'next/image';
import random from 'lodash/random';

import type { ComponentsPeopleLooking } from 'queries/graphql';

import { useTextFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';
import { buildImgProps } from 'utils/media';

import styles from './styles.module.scss';

const getRandom = () => random(15, 30);

export default function PeopleLooking({ sectionId, icon, style }: ComponentsPeopleLooking) {
  const { textColor, backgroundColor, textFont, glowColor } = style || {};

  const textFontOverrides = useTextFontOverrides(textFont);

  // Track whether the component is mounted on the client
  const [isMounted, setIsMounted] = useState(false);
  const [peopleLooking, setPeopleLooking] = useState(15); // Use a default value for SSR

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (isMounted) {
      setPeopleLooking(getRandom());
      const intervalId = setInterval(() => setPeopleLooking(getRandom()), 5000);
      return () => clearInterval(intervalId); // Cleanup
    }
  }, [isMounted]);

  return (
    <div id={sectionId} className={`root ${styles.container} peopleLooking`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
          ${buildCssVar('--background-color', backgroundColor, 'var(--default-background-color)')}
          ${buildCssVar('--icon-glow-color', glowColor, 'transparent')}
          ${textFontOverrides ?? ''}
        }
      `}</style>

      {icon && (
        <div className={styles.icon_container}>
          <div className={styles.icon_wrapper}>
            <Image {...buildImgProps(icon)} alt={icon.alt || 'People looking'} />
          </div>
          {glowColor && <div className={styles.glow_effect}></div>}
        </div>
      )}
      <div className={styles.text}>
        <span className={styles.emphasized}>Over {peopleLooking} people</span> looking at this deal
        right now
      </div>
    </div>
  );
}
